import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  EXPLORE_BANNERS_ADD_PATH,
  EXPLORE_BANNERS_PATH,
  EXPLORE_BANNERS_UPDATE_PATH,
} from "utils/constants/paths";

const ExploreBanners = Loadable(React.lazy(() => import("./View")));
const ExploreBannersAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const ExploreBannersRoute: IRouteItem = {
  path: EXPLORE_BANNERS_PATH,
  iconName: "Image",
  element: React.createElement(ExploreBanners),
  name: "Explore Banners",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: EXPLORE_BANNERS_ADD_PATH,
      element: React.createElement(ExploreBannersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: EXPLORE_BANNERS_UPDATE_PATH,
      element: React.createElement(ExploreBannersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
